import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';

import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit } from '@angular/core';

import { AxonAlertModel } from '@lib/axon';
import { ALERT_NOTIFICATION_VERSION } from '@lib/axon/services/alerts.constants';

enum ToastAnimationState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  REMOVED = 'removed',
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[fs-axon-alerts-toast]',
  templateUrl: './axon-alerts-toast.component.html',
  styleUrls: ['./axon-alerts-toast.component.scss'],
  preserveWhitespaces: false,
  animations: [
    trigger('flyInOut', [
      state(
        ToastAnimationState.INACTIVE,
        style({
          opacity: 0,
        }),
      ),
      transition(
        `${ToastAnimationState.INACTIVE} => ${ToastAnimationState.ACTIVE}`,
        animate(
          '400ms ease-out',
          keyframes([
            style({
              transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
              opacity: 0,
            }),
            style({
              transform: 'skewX(20deg)',
              opacity: 1,
            }),
            style({
              transform: 'skewX(-5deg)',
              opacity: 1,
            }),
            style({
              transform: 'none',
              opacity: 1,
            }),
          ]),
        ),
      ),
      transition(
        `${ToastAnimationState.ACTIVE} => ${ToastAnimationState.REMOVED}`,
        animate(
          '400ms ease-out',
          keyframes([
            style({
              opacity: 1,
            }),
            style({
              transform: 'translate3d(100%, 0, 0) skewX(30deg)',
              opacity: 0,
            }),
          ]),
        ),
      ),
    ]),
  ],
})
export class AxonAlertsToastComponent extends Toast implements OnInit {
  cxVersion?: string;

  get dockBodyCamera$(): Observable<void> {
    return this._dockBodyCamera$.asObservable();
  }

  get dockNearbyCameras$(): Observable<void> {
    return this._dockNearbyCameras$.asObservable();
  }

  get followMode$(): Observable<void> {
    return this._followMode$.asObservable();
  }

  get multipleReportString(): string {
    return `Multiple Reports Detected!`;
  }

  public axonAlert: AxonAlertModel;
  public count: number = 1;

  private readonly _dockBodyCamera$ = new Subject<void>();
  private readonly _dockNearbyCameras$ = new Subject<void>();
  private readonly _followMode$ = new Subject<void>();

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    public element: ElementRef,
  ) {
    super(toastrService, toastPackage);
    this.cxVersion = ALERT_NOTIFICATION_VERSION.LEGACY_CX;

  }

  public ngOnInit(): void {
    this.axonAlert = this.toastPackage.config.payload;
  }

  public dockBodyCamera(): void {
    this._dockBodyCamera$.next();
  }

  public dockNearbyCameras(): void {
    this._dockNearbyCameras$.next();
  }

  public followMode(): void {
    this._followMode$.next();
  }

  public close(): void {
    this.remove();
  }
}
